import { create, enforce, group, only, test } from "vest"

import { Leaderboard } from "src/app/consts/types"
import {
  ValidationContext,
  ValidationSuite,
  ValidationSuiteFn
} from "../validation"

/** Company Synchronous Validation Suite */
export const leaderboardSyncValidationSuite: ValidationSuite = create(
  "StreamEventSyncValidationSuite",
  (
    /** The object with data to validate */
    model: Partial<Leaderboard>,
    /** The property of that data to validate, if we only want to validate one property */
    field?: string,
    /** The group of properties in that data to validate, if we only want to validate one group */
    groupName?: string,
    /** Extra resources that a validator might need */
    context?: ValidationContext
  ) => {
    only(field) // if field defined, limit to tests of this field
    only.group(groupName) // if groupName defined, limit to tests of this group
    group("leaderboard", () =>
      leaderboardSyncValidations(model, field, groupName, context)
    )
    group("definition", () =>
      leaderboardDefSyncValidations(
        model.definition!,
        field,
        groupName,
        context
      )
    )
  }
)

/** Company Synchronous Validations, written in vest. */
export const leaderboardSyncValidations: ValidationSuiteFn = (
  model: Partial<Leaderboard>
) => {
  model = model ?? {}

  test("definition", "leaderboard definition is required", () => {
    enforce(model.definition).isNotBlank()
  })
  // omitWhen(!model.gameName, () => {
  //   test("gameName", "Game Name must be at least 3 characters long", () => {
  //     enforce(model.gameName).longerThanOrEquals(3)
  //   })
  // })
}

export const leaderboardDefSyncValidations: ValidationSuiteFn = (
  model: Partial<Leaderboard["definition"]>
) => {
  model = model ?? {}

  test("name", "Leaderboard def name is required", () => {
    enforce(model.name).isNotBlank()
  })
}
